import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { getBasketData } from 'services/getBasketData';
import { FetchInactiveBasketPayload, InactiveBasketsState } from 'types/baskets';
import { getDefaultCompanyId } from 'utils/helpers';

const initialState: InactiveBasketsState = {
    records: [],
    loading: true,
    error: null,
    loadMore: false,
};

export const fetchInactiveBaskets = createAsyncThunkWrapper<any, FetchInactiveBasketPayload>(
    'inactiveBaskets/fetchInactiveBaskets',
    async ({ headers, name }: FetchInactiveBasketPayload, { getState }) => {
        const { pageSize, pageNumber } = headers;
        const state: any = getState();
        const defaultCompanyId = getDefaultCompanyId(state);
        if (!defaultCompanyId) {
            return;
        }
        const response = await getBasketData({ status: ['PENDING', 'CLOSED'], companyId: defaultCompanyId, headers, name });
        if (!response) return;
        return { response, pageNumber, pageSize };
    }
);

const inactiveBasketsSlice = createSlice({
    name: 'inactiveBaskets',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchInactiveBaskets.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchInactiveBaskets.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action || {};
            if (!Array.isArray(payload?.response?.events)) return;

            const { response, pageNumber, pageSize = 0 } = payload || {};
            const { events } = response || {};
            state.loadMore = events?.length >= pageSize;

            state.records = !pageNumber ? events || [] : [...(state?.records || []), ...(events || [])];
        });
        builder.addCase(fetchInactiveBaskets.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || null;
        });
    },
});

export default inactiveBasketsSlice.reducer;
